module.exports = __webpack_public_path__ + "img/google.cfd659af.svg";